import libReducers from '@lootboy/lib/reducers';
import legalAppSlice from '@lootboy/lib/reducers/legalApp';

import alertsReducer from './alerts';
import soundReducer from './sound';

export default {
  ...libReducers,
  sound: soundReducer,
  alerts: alertsReducer,
  ...legalAppSlice,
};
